import { USER_FAILED, USER_LOADING, USER_REMOVE, USER_SUCCESS } from "../types";
import api from "../../api";
import {
  addParenUserEndpoint,
  addUserEndpoint,
  deleteUserEndpoint,
  deleteUsersEndpoint,
  getAllUsersEndpoint,
  getUsersByPartnerEndpoint,
  updateUserEndpoint,
} from "../../api/apisUrl";

export const handleUserCrudOperation = (
  type: "get" | "post" | "put" | "delete" | "getByPartner" | "postUsers",
  data?: any,
  token?: string,
  partnerId?: string
) => {
  return async (dispatch: any) => {
    dispatch({ type: USER_LOADING, loading: true });

    const callApi = async () => {
      switch (type) {
        case "post":
          if (!partnerId) throw new Error("partnerId is required for POST");
          return await api.post(addUserEndpoint(partnerId), data, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

        case "getByPartner":
          if (!partnerId) throw new Error("partnerId is required for POST");
          return await api.get(
            getUsersByPartnerEndpoint(
              partnerId,
              data.pageNumber,
              data.pageSize
            ),
            { headers: { Authorization: `Bearer ${token}` } }
          );

        case "get":
          return await api.get(
            getAllUsersEndpoint(data.pageNumber, data.pageSize, data.keyword),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

        // case "put":
        //   return await api.put(updateUserEndpoint(partnerId), data, {
        //     headers: {
        //       "Content-Type": "application/json",
        //       Authorization: `Bearer ${token}`,
        //     },
        //   });

        case "put": {
          const {
            partnerUser_name,
            email,
            phoneNumber,
            role,
            partnerId: partnerIdBody,
            status,
          } = data ?? {};

          const body = {
            partnerUser_name: String(partnerUser_name ?? "").trim(),
            email: String(email ?? "").trim(),
            phoneNumber: String(phoneNumber ?? ""),
            role: role ?? "partner",
            partnerId: partnerIdBody,
            status,
          };

          return await api.put(updateUserEndpoint(partnerId as string), body, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });
        }

        case "postUsers":
          return await api.post(addParenUserEndpoint(), data, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

        case "delete":
          return await api.delete(deleteUsersEndpoint(data.id), {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          });

        default:
          throw new Error(`Unsupported CRUD type: ${type}`);
      }
    };

    try {
      const res = await callApi();
      dispatch({ type: USER_LOADING, loading: false });
      dispatch({
        type: USER_SUCCESS,
        payload: res.data,
        status: res.status,
        request: type,
      });
      return { data: res.data, error: null };
    } catch (err: any) {
      dispatch({ type: USER_LOADING, loading: false });

      const errorMessage = err.response?.data?.message || err.message;

      dispatch({
        type: USER_FAILED,
        status: err.response?.status,
        error: errorMessage,
        request: type,
      });
      return { error: errorMessage, data: null };
    }
  };
};

export const removeUserCrudOperation = () => ({
  type: USER_REMOVE,
});
